import React from 'react';

import Editor from 'draft-js-plugins-editor';
import { Separator } from 'draft-js-static-toolbar-plugin';
import {
  ItalicButton,
  BoldButton,
  UnderlineButton,
  CodeButton,
  UnorderedListButton,
  OrderedListButton,
  BlockquoteButton
} from 'draft-js-buttons';
import { HeadlinesButton } from '../../internal-components/CustomToolbarEditor';
import LinkButton from '../HyperLink4TextEditor';
import Select from '../engine/SelectEngine';

import MuiTooltip from '@material-ui/core/Tooltip';

import styled from 'styled-components/macro';

const Container = styled.div`
  border-radius: 4px;
  border: 1px solid #cccccc;
  height: ${({ height }) => height}px;
  overflow-y: hidden;

  div[class^='draftJsToolbar__toolbar'] {
    background: #f8f9fa;
    display: flex;
    align-items: center;
  }
`;

const EditorWrapper = styled.div`
  width: 100%;
  height: ${({ height }) => (height ? height - 50 + 'px' : '100%')};
  padding: 0.8em;
  overflow-y: auto;
  white-space: pre;
`;
const PlaceHolderOptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Tooltip = props => (
  <MuiTooltip {...props}>
    <span>{props.children}</span>
  </MuiTooltip>
);

const TextEditorView = props => {
  const { Toolbar } = props.toolbarPlugin;

  return (
    <Container
      height={props.editorHeight}
      onClick={() => props.editorEl && props.editorEl.focus()}
    >
      <Toolbar>
        {externalProps => (
          <>
            <Tooltip title="Bold" arrow>
              <BoldButton {...externalProps} />
            </Tooltip>
            <Tooltip title="Italic" arrow>
              <ItalicButton {...externalProps} />
            </Tooltip>
            <Tooltip title="Underline" arrow>
              <UnderlineButton {...externalProps} />
            </Tooltip>
            <Tooltip title="Code" arrow>
              <CodeButton {...externalProps} />
            </Tooltip>
            <Separator {...externalProps} />
            <Tooltip title="Title" arrow>
              <HeadlinesButton {...externalProps} />
            </Tooltip>
            <Tooltip title="Unordered list" arrow>
              <UnorderedListButton {...externalProps} />
            </Tooltip>
            <Tooltip title="Ordered list" arrow>
              <OrderedListButton {...externalProps} />
            </Tooltip>
            <Tooltip title="Quote" arrow>
              <BlockquoteButton {...externalProps} />
            </Tooltip>
            <Tooltip title="Hyperlink" arrow>
              <LinkButton
                editorState={props.editorState}
                setEditorState={props.setEditorState}
                {...externalProps}
              />
            </Tooltip>
            {props.fieldsPlaceholders && props.fieldsPlaceholders.length ? (
              <>
                <Separator {...externalProps} />
                <Select
                  searchable
                  options={props.fieldsPlaceholders}
                  onChange={props.insertPlaceHolder}
                  placeholder="Insert placeholder"
                  openMenuOptionParser={opt => (
                    <PlaceHolderOptionWrapper>
                      <label>{opt.description}</label>
                      <small>{opt.text}</small>
                    </PlaceHolderOptionWrapper>
                  )}
                />
              </>
            ) : null}
            {props.additionalPlaceHolders &&
            props.additionalPlaceHolders.length ? (
              <>
                <Separator {...externalProps} />
                <Select
                  searchable
                  options={props.additionalPlaceHolders}
                  onChange={props.insertPlaceHolder}
                  placeholder="Insert placeholder"
                  openMenuOptionParser={opt => (
                    <PlaceHolderOptionWrapper>
                      <label>{opt.description}</label>
                      <small>{opt.text}</small>
                    </PlaceHolderOptionWrapper>
                  )}
                  {...props.additionalPlaceHoldersProps}
                />
              </>
            ) : null}
          </>
        )}
      </Toolbar>
      <EditorWrapper height={props.editorHeight} data-testid='editor-body'>
        <Editor
          editorState={props.editorState}
          onChange={props.setEditorState}
          plugins={props.plugins}
          ref={element => props.setEditorEl(element)}
        />
      </EditorWrapper>
    </Container>
  );
};

export default TextEditorView;
